import { Navigate } from 'react-router-dom'

import { AuthLoading } from '@/components/auth/AuthLoading'
import { useAuth } from '@/contexts/AuthContext'
import { hasAnyEffectivePermission } from '@/lib/permissions'

export function PermissionRoute({ permission, children }) {
  const { user, loading, isAuthenticated } = useAuth()

  if (loading) {
    return <AuthLoading />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!hasAnyEffectivePermission(user, permission)) {
    return <Navigate to="/" replace />
  }

  return children
}
